import { Inject, Injectable } from '@angular/core';
import { Building } from '@app/shared/models/building.interface';
import { Environment, environmentToken } from '@environment';
import { IBuildingMetadataService } from './building-metadata.interface';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { NavigationService } from '@services/navigation/navigation.service';
import { UserService } from '@services/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class BuildingMetadataService implements IBuildingMetadataService {
  private readonly baseUrl: string;

  constructor(
    @Inject(environmentToken) environment: Environment,
    private navigationService: NavigationService,
    private userService: UserService
  ) {
    const { apiUrl, apiPath } = environment;
    this.baseUrl = apiUrl + apiPath;
  }

  thumbnailUrl(building: Building): string {
    return building.thumbnailImage
      ? `${this.baseUrl}/building/${building.id}/thumbnail?id=${building.thumbnailImage}`
      : undefined;
  }

  floorUrl(id: number): string {
    return `/buildings/${id}/administration/floors`;
  }

  produceBuildingUrl(building: Building): Observable<string> {
    if (building.floors.length === 0) {
      return of(this.floorUrl(building.id));
    } else {
      const siteMenu = this.navigationService.getSiteMenu();

      return this.userService.getCurrentUser().pipe(
        map((user) => {
          for (const nav of siteMenu) {
            const canViewNav = nav.info.isAuthorized(user, building.id);
            if (canViewNav) {
              return nav.getRoute(building.id, building.floors[0]?.id);
            }
          }
        })
      );
    }
  }
}
